import { forwardRef } from 'react'
import { IconProps } from 'blaze-ui/icons/Types'
import HighDetailedMail from 'blaze-ui/icons/40/HighDetailedMail'

export const DynamicHighDetailedMail = forwardRef<SVGSVGElement, IconProps>((props, forwardedRef) => {
  return <HighDetailedMail {...props} ref={forwardedRef} />
})

export default DynamicHighDetailedMail
